import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Form , Container, Alert, Spinner, Card, Row, Col, ButtonGroup, Button, Image, Breadcrumb, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DataManager } from '../../core/data-manager';
import { ResourceManager } from '../../core/resource-manager';
import { LanguageProvider } from '../../core/language-provider';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import blogDefault from '../../assets/entry-default.jpg';
import { settings } from '../../config/settings';
import Breadcrumbs from '../../components/Breadcrumbs';
import nodisp from '../../assets/nodisp.jpeg';
import logo from '../../assets/logo.svg';
import { getPhotoUrl } from '../../utilies/getPhotoUrl.js';
import { useQuery } from '@tanstack/react-query';
import CustomPagination from '../../components/CustomPagination.tsx';
import useDebounce from '../../utilies/useDebounce.js';

function ContainerItem({ data }) {
    return (
        <Container fluid='md' className='mt-5 mb-5'>
            <div className='container'>
                <div className='row row-cols-md-4 row-cols-2'>
                    {data.sort((a, b) => {
                        return parseInt(a.code) - parseInt(b.code);
                    }).map(item => {
                        console.log({item});
                        return ProductItem({item});
                    })}
                </div>

            </div>
        </Container>
    );
}

function ProductItem({item}){
    return (
        <Link to={`/dettaglio/${item.id}`} className="text-decoration-none mb-4 pb-4">
            <div className='flex flex-col flex-nowrap align-items-start justify-content-center gap-0' key={item.id}>
                <div className="position-relative">
                {item && item.photo && item.photo.entity ?
                    <Image src={ `${getPhotoUrl(item.photo.entity, item.photo.hash, item.photo.extension)}`} style={{ width: '100%' , height: 'fit-content' , minHeight: '200px' , objectFit: 'cover' , aspectRatio: '3/4' }} className='mb-1 rounded-2' />
                    :
                    <Image src={nodisp} style={{ width: '100%', maxHeight: '300px' }}></Image>
                }
                </div>
                <h6 className="text-decoration-none text-center mt-1 mb-0 p-0">{item.name}</h6>
            </div>
        </Link>
    )
}

export function CardItem( item ) {

    const url = settings.ckdPath;

    return (
        <Link to={`/dettaglio/${item.id}`}>
            <div className='flex flex-col' key={item.id}>
                {item && item.photo && item.photo.entity ?
                    <Image src={url + 'upload/' + item.photo.entity + '/' + item.photo.hash + '.' + item.photo.extension} style={{ width: '100%' }} className='mb-1' />
                    :
                    <Image src={nodisp} style={{ width: '100%', maxHeight: '300px' }}></Image>}
            
                <p>{item.name}</p>
            </div>
        </Link>
    )
}

function CategoryDropdown({ categories, selectedCategories, onToggle, onClear, hideCount = false , className='' , classNameToggle='' , classNameMenu='' }) {
    const [hoverClear, setHoverClear] = useState(false);

    const label = selectedCategories.length === 0
        ? 'Categoria'
        : selectedCategories.length === 1
            ? categories.find(c => c.id === selectedCategories[0])?.name || 'Categoria'
            : `${selectedCategories.length} categorie`;

    return (
        <Dropdown autoClose="outside" className={className}>
            <Dropdown.Toggle
                variant={selectedCategories.length > 0 ? 'danger text-white' : 'outline-secondary'}
                className={"rounded-pill px-3" + classNameToggle }
                style={{ minWidth: '160px' }}
            >
                <FontAwesomeIcon icon="filter" size="sm" className="me-2" />
                {label}
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ minWidth: '200px' }} className={classNameMenu}>
                {categories.length === 0 && (
                    <Dropdown.Item disabled>Nessuna categoria</Dropdown.Item>
                )}
                {categories.map(cat => (
                    <Dropdown.Item
                        as="div"
                        key={cat.id}
                        onClick={() => onToggle(cat.id)}
                        className="d-flex align-items-center gap-2 px-3 py-2"
                        style={{ cursor: 'pointer' }}
                    >
                        <Form.Check
                            type="checkbox"
                            id={`cat-${cat.id}`}
                            checked={selectedCategories.includes(cat.id)}
                            onChange={() => {}}
                            onClick={e => { e.stopPropagation(); onToggle(cat.id); }}
                        />
                        <label htmlFor={`cat-${cat.id}`} className="mb-0 d-flex align-items-center gap-2" style={{ cursor: 'pointer' }} onClick={e => e.stopPropagation()}>
                            {cat.name}
                            {
                                !hideCount && (
                                    <span className="opacity-50 small">({cat.count})</span>
                                )
                            }
                        </label>
                    </Dropdown.Item>
                ))}
                {selectedCategories.length > 0 && (
                    <>
                        <Dropdown.Divider />
                        <Dropdown.Item
                            onClick={onClear}
                            onMouseEnter={() => setHoverClear(true)}
                            onMouseLeave={() => setHoverClear(false)}
                            className="text-center small fw-medium"
                            style={{
                                color: hoverClear ? '#fff' : '#dc3545',
                                backgroundColor: hoverClear ? '#dc3545' : 'transparent',
                            }}
                        >
                            Rimuovi filtri
                        </Dropdown.Item>
                    </>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
}

function ContainerNoData() {
    return (
        <div style={{ height: '70vh' }} className='w-100 d-flex flex-column align-items-center justify-content-center'>
            {/* <img src={logo} alt="Annamaria" className='w-25 d-block m-4'/> */}
            <h2 className='text-center p-10'>Nessun prodotto disponibile</h2>
            <Button as={Link} to='/' variant='danger' className='m-4' style={{ color: 'white' }}>Torna alla home</Button>
        </div>
    )
}

export default function Collection() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');

    const [searchParams, setSearchParams] = useSearchParams();
    const isFirstRender = useRef(true);

    const { k } = useParams();
    const id = parseInt(k);

    const [linea, setLinea] = useState(3);
    const [title, setTitle] = useState('');
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState(() => searchParams.get('q') || '');
    const debouncedSearchText = useDebounce(searchText, 500);
    const [lastFetchResults , setLastFetchResults] = useState(undefined);
    const [pageData , setPageData] = useState({
        first_page: 1,
        prev_page: 1,
        current_page: 1,
        next_page: 1,
        last_page: 1
    });
    const [categories, setCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState(() => {
        const cats = searchParams.get('categories');
        return cats ? cats.split(',').map(Number).filter(Boolean) : [];
    });
    const [totalResults, setTotalResults] = useState(null);

    useEffect(() => {
        const params = {};
        if (debouncedSearchText) params.q = debouncedSearchText;
        if (selectedCategories.length > 0) params.categories = selectedCategories.join(',');
        setSearchParams(params, { replace: true });
    }, [debouncedSearchText, selectedCategories, setSearchParams]);

    useEffect(() => {
        if (!isFirstRender.current) {
            setSelectedCategories([]);
            setSearchText('');
        }
        isFirstRender.current = false;
        DataManager.searchItems(
            'gyv_line_category_stats',
            1, 200,
            { field: 'categoryName', order: 'asc' },
            '', [],
            [{ fieldName: 'idLine', type: 'value', value: id }]
        )
            .then(response => {
                if (response.success === 1) {
                    setCategories(
                        (response.body || []).map(item => ({
                            id: item.idCategory?.id ?? item.idCategory,
                            name: item.categoryName,
                            count: item.modelCount
                        })).filter(cat => cat.id != null)
                    );
                }
            })
            .catch(err => console.error(err));
    }, [id]);

    function toggleCategory(categoryId) {
        setPage(1);
        setSelectedCategories(prev =>
            prev.includes(categoryId)
                ? prev.filter(id => id !== categoryId)
                : [...prev, categoryId]
        );
    }

    function clearCategories() {
        setSelectedCategories([]);
        setPage(1);
    }

    async function fetch() {

        var constraints = [
            {
                "fieldName": "idLine",
                "type": "value",
                "value": id
            }
        ];

        console.log('selectedCategories:', selectedCategories); 

        if (selectedCategories.length > 0) {
            constraints.push({
                fieldName: 'idCategory',
                type: 'in',
                value: selectedCategories.join(',')
            });
        }

        var sorting = {
            'field': 'code',
            'order': 'asc'
        };

        DataManager.getItem('line', id)
        .then(response => {
            if (response.success !== 1) {
                throw new Error;
            }
            setTitle(response.body[0].name);
        })
        .catch(error => {
            setTitle('');
            console.error(error);
        });

        const query = debouncedSearchText;
        let fields = [];
        if(query){
            fields = ['code' , 'name'];
        }

        return await DataManager.searchItems('model', page, 300, sorting, query, fields, constraints);

    }

    const fetchData = useQuery({
        queryKey: ['collection', id, page, debouncedSearchText, selectedCategories],
        queryFn: () => fetch(),
    })

    useEffect(() => {
        if(fetchData.data){
            const prev_page_number = page - 1 > 0 ? page - 1 : 1;
            const next_page_number = page + 1 > fetchData.data.pages ? fetchData.data.pages : page + 1;
            setPageData({
                first_page: 1,
                prev_page: prev_page_number,  
                current_page: page,
                next_page: next_page_number,
                last_page: fetchData.data.pages
            });
            setLastFetchResults(fetchData.data.body);
            setTotalResults(fetchData.data.total ?? fetchData.data.body?.length ?? null);
        }
    }, [fetchData.data]);

    

    return (
        <>
            <Container className='mt-3 mb-4'>
                <Breadcrumbs title={title}></Breadcrumbs>
                <div className='d-flex flex-column flex-md-row-reverse align-items-stretch align-items-md-center justify-content-md-start gap-3 mt-3 px-2'>
                    <CategoryDropdown
                        categories={categories}
                        selectedCategories={selectedCategories}
                        onToggle={toggleCategory}
                        onClear={clearCategories}
                        hideCount={ searchText ? true : false }
                        classNameToggle=' w-100'
                    />
                    <div className='rounded-pill d-flex align-items-center'>
                        <Form.Control className={'rounded-0 rounded-start-pill px-3'} type="text" name="query" aria-label="Ricerca" placeholder={"Cerca Prodotto"} value={searchText} onChange={ e => setSearchText(e.target?.value) } />
                        <Button className='rounded-0 rounded-end-pill btn btn-danger text-white' onClick={(e) => {e.preventDefault();}}><FontAwesomeIcon icon={'search'} size='sm'/></Button>
                    </div>
                    <div className='d-flex align-items-center justify-content-between justify-content-md-end gap-3'>
                        {(selectedCategories.length > 0 || searchText) && (
                            <Button
                                variant='link'
                                className='text-danger p-0 small text-decoration-none'
                                onClick={() => { clearCategories(); setSearchText(''); }}
                            >
                                <FontAwesomeIcon icon='times' size='sm' className='me-1' />
                                Svuota filtri
                            </Button>
                        )}
                        {totalResults !== null && (
                            <span className='text-muted small'>
                                {totalResults} {totalResults === 1 ? 'risultato' : 'risultati'}
                            </span>
                        )}
                    </div>
                </div>
            </Container>
            {
                !fetchData.isLoading ? 
                    (
                        lastFetchResults && lastFetchResults.length > 0 ?
                        <>
                            <ContainerItem key={id} data={lastFetchResults}></ContainerItem>
                            <Container className='d-flex align-items-center justify-content-end mt-3 mb-5'>
                                <CustomPagination pageData={pageData} setPage={setPage} />
                            </Container>
                            
                        </>

                        :
                        <ContainerNoData></ContainerNoData>
                    )
                    :
                    <div style={{ height: '70vh' }} className='w-100 d-flex flex-column align-items-center justify-content-center'>
                        <div className="spinner-border text-danger" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
            }
        </>
    )


};